module.exports = __webpack_public_path__ + "img/nav-web-hosting-icon.22835f7b.svg";